var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "title" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "/" } },
            [
              _c("el-breadcrumb-item", [_vm._v("设施运维")]),
              _c("el-breadcrumb-item", [_vm._v("工程服务")]),
              _c(
                "el-breadcrumb-item",
                {
                  attrs: {
                    to: { path: "/facilityManage/formal/technicalReform" }
                  }
                },
                [_vm._v("技术改造")]
              ),
              _c("el-breadcrumb-item", [_vm._v("项目详情")])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "process-flow" },
        [
          _c("div", { staticClass: "title-en" }, [_vm._v("项目流程")]),
          _c(
            "el-card",
            { staticClass: "flow-card", attrs: { shadow: "hover" } },
            [
              _c(
                "el-steps",
                { attrs: { active: _vm.getActiveStep(), "align-center": "" } },
                [
                  _c(
                    "el-step",
                    {
                      attrs: { title: "创建项目", icon: "el-icon-video-play" }
                    },
                    [
                      _c("template", { slot: "description" }, [
                        _c("div", { staticClass: "step-desc" }, [
                          _c("div", [
                            _vm._v(_vm._s(_vm.formData.creator || "-"))
                          ]),
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.formatTime(_vm.formData.create_time) || "-"
                              )
                            )
                          ])
                        ])
                      ])
                    ],
                    2
                  ),
                  _c(
                    "el-step",
                    {
                      attrs: {
                        title: "提交方案",
                        icon:
                          _vm.formData.operation_status == "1"
                            ? "el-icon-loading"
                            : "el-icon-upload2"
                      }
                    },
                    [
                      _c("template", { slot: "description" }, [
                        _c("div", { staticClass: "step-desc" }, [
                          _c("div", [
                            _vm._v(_vm._s(_vm.formData.auditor || "-"))
                          ]),
                          _c("div", [
                            _vm._v(_vm._s(_vm.getLastSubmitTime() || "-"))
                          ])
                        ])
                      ])
                    ],
                    2
                  ),
                  _c(
                    "el-step",
                    {
                      attrs: {
                        title: "方案审核",
                        icon:
                          _vm.formData.operation_status == "2"
                            ? "el-icon-loading"
                            : "el-icon-edit-outline"
                      }
                    },
                    [
                      _c("template", { slot: "description" }, [
                        _c("div", { staticClass: "step-desc" }, [
                          _c("div", [
                            _vm._v(_vm._s(_vm.formData.auditor || "-"))
                          ]),
                          _c("div", [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.getApprovedTime || "-") +
                                "\n                "
                            )
                          ])
                        ])
                      ])
                    ],
                    2
                  ),
                  _c(
                    "el-step",
                    {
                      attrs: {
                        title: "确认归档",
                        icon:
                          _vm.formData.operation_status == "3"
                            ? "el-icon-loading"
                            : "el-icon-folder-checked"
                      }
                    },
                    [
                      _c("template", { slot: "description" }, [
                        _c("div", { staticClass: "step-desc" }, [
                          _c("div", [
                            _vm._v(_vm._s(_vm.formData.auditor || "-"))
                          ]),
                          _c("div", [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.getApprovedTime || "-") +
                                "\n                "
                            )
                          ])
                        ])
                      ])
                    ],
                    2
                  ),
                  _c(
                    "el-step",
                    { attrs: { title: "归档完成", icon: "el-icon-check" } },
                    [
                      _c("template", { slot: "description" }, [
                        _c("div", { staticClass: "step-desc" }, [
                          _c("div", [
                            _vm._v(_vm._s(_vm.formData.auditor || "-"))
                          ]),
                          _vm.latestRecord.operation_type === "archive"
                            ? _c("div", [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.formatTime(
                                        _vm.latestRecord.operation_time
                                      ) || "-"
                                    ) +
                                    "\n                "
                                )
                              ])
                            : _vm._e()
                        ])
                      ])
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        [
          _c("div", { staticClass: "title-en" }, [_vm._v("基础信息")]),
          _c(
            "el-card",
            { staticClass: "info-card" },
            [
              !_vm.isEditing
                ? [
                    _c(
                      "el-descriptions",
                      { attrs: { column: 3, border: "" } },
                      [
                        _c(
                          "el-descriptions-item",
                          { attrs: { label: "项目名称" } },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.formData.project_name || "-") +
                                "\n            "
                            )
                          ]
                        ),
                        _c(
                          "el-descriptions-item",
                          { attrs: { label: "项目地点" } },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.formData.project_location || "-") +
                                "\n            "
                            )
                          ]
                        ),
                        _c(
                          "el-descriptions-item",
                          { attrs: { label: "创建人" } },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.formData.creator || "-") +
                                "\n            "
                            )
                          ]
                        ),
                        _c(
                          "el-descriptions-item",
                          { attrs: { label: "创建日期" } },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.formatTime(_vm.formData.create_time) ||
                                    "-"
                                ) +
                                "\n            "
                            )
                          ]
                        ),
                        _c(
                          "el-descriptions-item",
                          { attrs: { label: "修改日期" } },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.formatTime(_vm.formData.modify_date) ||
                                    "-"
                                ) +
                                "\n            "
                            )
                          ]
                        ),
                        _c(
                          "el-descriptions-item",
                          { attrs: { label: "项目类型" } },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.formData.project_type || "-") +
                                "\n            "
                            )
                          ]
                        ),
                        _c(
                          "el-descriptions-item",
                          { attrs: { label: "项目状态" } },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.formData.audit_status || "-") +
                                "\n            "
                            )
                          ]
                        ),
                        _c(
                          "el-descriptions-item",
                          { attrs: { label: "客户名称" } },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.formData.customer_name || "-") +
                                "\n            "
                            )
                          ]
                        ),
                        _c(
                          "el-descriptions-item",
                          { attrs: { label: "方案负责人" } },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.formData.solution_manager || "-") +
                                "\n            "
                            )
                          ]
                        ),
                        _c(
                          "el-descriptions-item",
                          { attrs: { label: "项目负责人" } },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.formData.project_manager || "-") +
                                "\n            "
                            )
                          ]
                        ),
                        _c(
                          "el-descriptions-item",
                          { attrs: { label: "附件", span: 24 } },
                          [
                            _vm.formData.attachments &&
                            _vm.formData.attachments.length > 0
                              ? _c(
                                  "div",
                                  _vm._l(_vm.formData.attachments, function(
                                    file,
                                    index
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        staticClass: "attachment-item"
                                      },
                                      [
                                        _c(
                                          "el-link",
                                          {
                                            attrs: { type: "primary" },
                                            on: {
                                              click: function($event) {
                                                return _vm.handlePreview(file)
                                              }
                                            }
                                          },
                                          [_vm._v(_vm._s(file.name))]
                                        )
                                      ],
                                      1
                                    )
                                  }),
                                  0
                                )
                              : _c("span", [_vm._v("-")])
                          ]
                        ),
                        _c(
                          "el-descriptions-item",
                          { attrs: { label: "项目描述", span: 24 } },
                          [
                            _c(
                              "div",
                              { staticStyle: { "white-space": "pre-line" } },
                              [_vm._v(_vm._s(_vm.formData.project_desc || "-"))]
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      {
                        staticStyle: { "margin-top": "20px" },
                        attrs: { gutter: 20 }
                      },
                      [
                        _c("el-col", { attrs: { span: 24 } }, [
                          _c(
                            "div",
                            { staticClass: "action-buttons" },
                            [
                              !_vm.isEditing
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "primary",
                                        disabled:
                                          _vm.formData.operation_status ==
                                            "3" ||
                                          _vm.formData.operation_status == "4"
                                      },
                                      on: { click: _vm.handleEdit }
                                    },
                                    [_vm._v("编辑")]
                                  )
                                : _vm._e(),
                              _vm.loginName === _vm.formData.auditor
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "success",
                                        disabled:
                                          _vm.formData.operation_status ==
                                            "1" ||
                                          _vm.formData.operation_status ==
                                            "3" ||
                                          _vm.formData.operation_status == "4"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.handleAudit("已通过")
                                        }
                                      }
                                    },
                                    [_vm._v("通过")]
                                  )
                                : _vm._e(),
                              _vm.loginName === _vm.formData.auditor
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "danger",
                                        disabled:
                                          _vm.formData.operation_status ==
                                            "1" ||
                                          _vm.formData.operation_status ==
                                            "3" ||
                                          _vm.formData.operation_status == "4"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.handleAudit("已驳回")
                                        }
                                      }
                                    },
                                    [_vm._v("不通过")]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ])
                      ],
                      1
                    )
                  ]
                : [
                    _c(
                      "el-form",
                      {
                        ref: "rejectedForm",
                        staticClass: "project-form",
                        attrs: {
                          model: _vm.formData,
                          rules: _vm.rules,
                          "label-width": "120px"
                        }
                      },
                      [
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "项目名称",
                                      prop: "project_name"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: { placeholder: "请输入项目名称" },
                                      model: {
                                        value: _vm.formData.project_name,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "project_name",
                                            $$v
                                          )
                                        },
                                        expression: "formData.project_name"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "项目类型",
                                      prop: "project_type"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          placeholder: "请选择项目类型"
                                        },
                                        model: {
                                          value: _vm.formData.project_type,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "project_type",
                                              $$v
                                            )
                                          },
                                          expression: "formData.project_type"
                                        }
                                      },
                                      _vm._l(_vm.projectTypeOptions, function(
                                        item
                                      ) {
                                        return _c("el-option", {
                                          key: item.value,
                                          attrs: {
                                            label: item.label,
                                            value: item.value
                                          }
                                        })
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "客户名称",
                                      prop: "customer_name"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          placeholder: "请选择客户名称"
                                        },
                                        model: {
                                          value: _vm.formData.customer_name,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "customer_name",
                                              $$v
                                            )
                                          },
                                          expression: "formData.customer_name"
                                        }
                                      },
                                      _vm._l(_vm.customerOptions, function(
                                        item
                                      ) {
                                        return _c("el-option", {
                                          key: item.value,
                                          attrs: {
                                            label: item.label,
                                            value: item.value
                                          }
                                        })
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "审核人员",
                                      prop: "auditor"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          placeholder: "请选择审核人员"
                                        },
                                        model: {
                                          value: _vm.formData.auditor,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "auditor",
                                              $$v
                                            )
                                          },
                                          expression: "formData.auditor"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: {
                                            label: "周德明",
                                            value: "周德明"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "项目地点",
                                      prop: "project_location"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: { placeholder: "请输入项目地点" },
                                      model: {
                                        value: _vm.formData.project_location,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "project_location",
                                            $$v
                                          )
                                        },
                                        expression: "formData.project_location"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "方案负责人",
                                      prop: "solution_manager"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        placeholder: "请输入方案负责人"
                                      },
                                      model: {
                                        value: _vm.formData.solution_manager,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "solution_manager",
                                            $$v
                                          )
                                        },
                                        expression: "formData.solution_manager"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "项目负责人",
                                      prop: "project_manager"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        placeholder: "请输入项目负责人"
                                      },
                                      model: {
                                        value: _vm.formData.project_manager,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "project_manager",
                                            $$v
                                          )
                                        },
                                        expression: "formData.project_manager"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "项目描述",
                                      prop: "project_desc"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        type: "textarea",
                                        rows: 4,
                                        placeholder:
                                          "请按以下格式填写：\n1.需求简述；\n2.客户技术/工勘联系人及电话\n3.期望日期"
                                      },
                                      model: {
                                        value: _vm.formData.project_desc,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "project_desc",
                                            $$v
                                          )
                                        },
                                        expression: "formData.project_desc"
                                      }
                                    }),
                                    _c("div", { staticClass: "form-tip" }, [
                                      _c("div", { staticClass: "tip-header" }, [
                                        _c("i", {
                                          staticClass: "el-icon-info"
                                        }),
                                        _c("span", [_vm._v("格式要求")])
                                      ]),
                                      _c(
                                        "div",
                                        { staticClass: "tip-content" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "tip-item" },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "tip-number" },
                                                [_vm._v("1.")]
                                              ),
                                              _c(
                                                "span",
                                                { staticClass: "tip-text" },
                                                [_vm._v("需求简述")]
                                              )
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "tip-item" },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "tip-number" },
                                                [_vm._v("2.")]
                                              ),
                                              _c(
                                                "span",
                                                { staticClass: "tip-text" },
                                                [
                                                  _vm._v(
                                                    "客户技术/工勘联系人及电话"
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "tip-item" },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "tip-number" },
                                                [_vm._v("3.")]
                                              ),
                                              _c(
                                                "span",
                                                { staticClass: "tip-text" },
                                                [_vm._v("期望日期")]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "附件",
                                      prop: "attachments"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-upload",
                                      {
                                        staticClass: "upload-demo",
                                        attrs: {
                                          action: "#",
                                          "http-request": _vm.handleUpload,
                                          "on-preview": _vm.handlePreview,
                                          "on-remove": _vm.handleRemove,
                                          "before-remove": _vm.beforeRemove,
                                          multiple: "",
                                          limit: 3,
                                          "on-exceed": _vm.handleExceed,
                                          "file-list": _vm.formData.attachments
                                        }
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              size: "small",
                                              type: "primary"
                                            }
                                          },
                                          [_vm._v("点击上传")]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "el-upload__tip",
                                            attrs: { slot: "tip" },
                                            slot: "tip"
                                          },
                                          [_vm._v("文件大小不超过50MB")]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c("el-col", { attrs: { span: 24 } }, [
                              _c(
                                "div",
                                { staticClass: "action-buttons" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: { click: _vm.handleSubmit }
                                    },
                                    [_vm._v("保存")]
                                  ),
                                  _c(
                                    "el-button",
                                    { on: { click: _vm.handleCancel } },
                                    [_vm._v("取消")]
                                  )
                                ],
                                1
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
            ],
            2
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "solution-submit" },
        [
          _c("div", { staticClass: "title-en" }, [_vm._v("方案提交")]),
          _c(
            "el-card",
            { staticClass: "solution-card" },
            [
              _c(
                "el-form",
                {
                  ref: "solutionForm",
                  attrs: {
                    model: _vm.solutionForm,
                    rules: _vm.solutionRules,
                    "label-width": "120px"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "方案附件", prop: "attachments" } },
                    [
                      _c(
                        "el-upload",
                        {
                          staticClass: "upload-demo",
                          attrs: {
                            action: "#",
                            "http-request": _vm.handleSolutionUpload,
                            "on-preview": _vm.handlePreview,
                            "on-remove": _vm.handleSolutionRemove,
                            "before-remove": _vm.beforeRemove,
                            multiple: "",
                            limit: 5,
                            "on-exceed": _vm.handleExceed,
                            "file-list": _vm.solutionForm.attachments,
                            accept: ".pdf,.doc,.docx,.xls,.xlsx"
                          }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                size: "small",
                                type: "primary",
                                disabled:
                                  _vm.formData.operation_status == "3" ||
                                  _vm.formData.operation_status == "4"
                              }
                            },
                            [_vm._v("\n                点击上传")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "el-upload__tip",
                              attrs: { slot: "tip" },
                              slot: "tip"
                            },
                            [
                              _c("div", [
                                _vm._v(
                                  "支持格式：PDF、Word、Excel，单个文件不超过50MB"
                                )
                              ]),
                              _c("div", [_vm._v("最多上传5个文件")])
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            loading: _vm.submitting,
                            disabled:
                              _vm.formData.operation_status == "3" ||
                              _vm.formData.operation_status == "4"
                          },
                          on: { click: _vm.submitSolution }
                        },
                        [_vm._v("提交方案")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.solutionList.length
        ? _c(
            "div",
            { staticClass: "solution-list" },
            [
              _c("div", { staticClass: "title-en" }, [_vm._v("已提交方案")]),
              _c("el-card", { staticClass: "solution-list-card" }, [
                _c(
                  "div",
                  { staticClass: "solution-items" },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      _vm._l(_vm.solutionList, function(solution, index) {
                        return _c(
                          "el-col",
                          { key: index, attrs: { span: 8 } },
                          [
                            _c(
                              "el-card",
                              {
                                staticClass: "solution-item",
                                attrs: { shadow: "hover" }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "solution-header" },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-document"
                                    }),
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          content: solution.file_name,
                                          placement: "top",
                                          disabled:
                                            solution.file_name.length <= 20
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "file-name" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                solution.file_name.length > 20
                                                  ? solution.file_name.substring(
                                                      0,
                                                      20
                                                    ) + "..."
                                                  : solution.file_name
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _c("div", { staticClass: "solution-info" }, [
                                  _c("div", { staticClass: "info-row" }, [
                                    _c("span", { staticClass: "label" }, [
                                      _vm._v("提交人：")
                                    ]),
                                    _c("span", [
                                      _vm._v(_vm._s(solution.submitter))
                                    ])
                                  ]),
                                  _c("div", { staticClass: "info-row" }, [
                                    _c("span", { staticClass: "label" }, [
                                      _vm._v("提交时间：")
                                    ]),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatTime(solution.submit_time)
                                        )
                                      )
                                    ])
                                  ]),
                                  _c("div", { staticClass: "info-row" }, [
                                    _c("span", { staticClass: "label" }, [
                                      _vm._v("文件大小：")
                                    ]),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          (solution.file_size / 1024).toFixed(2)
                                        ) + " KB"
                                      )
                                    ])
                                  ])
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "solution-actions" },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "delete-btn",
                                        staticStyle: { color: "#f56c6c" },
                                        attrs: { type: "text" },
                                        on: {
                                          click: function($event) {
                                            return _vm.deleteTechnicalSolutionAttachment(
                                              solution
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("删除")]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text", size: "mini" },
                                        on: {
                                          click: function($event) {
                                            return _vm.handleDownload(solution)
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-download"
                                        }),
                                        _vm._v(" 下载\n                  ")
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text", size: "mini" },
                                        on: {
                                          click: function($event) {
                                            return _vm.handleFileSaveAs(
                                              solution
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-folder-add"
                                        }),
                                        _vm._v(" 另存为\n                  ")
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ],
                          1
                        )
                      }),
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "audit-records" },
        [
          _c("div", { staticClass: "title-en" }, [_vm._v("操作步骤")]),
          _c(
            "el-card",
            { staticClass: "audit-steps-card" },
            [
              _c(
                "el-collapse",
                {
                  model: {
                    value: _vm.activeSteps,
                    callback: function($$v) {
                      _vm.activeSteps = $$v
                    },
                    expression: "activeSteps"
                  }
                },
                _vm._l(_vm.auditRecords, function(record, index) {
                  return _c(
                    "el-collapse-item",
                    { key: index, attrs: { name: index } },
                    [
                      _c("template", { slot: "title" }, [
                        _c("div", { staticClass: "step-header" }, [
                          _c("i", {
                            staticClass: "operation-icon",
                            class: _vm.getOperationIcon(record.audit_status)
                          }),
                          _c("span", { staticClass: "step-title" }, [
                            _vm._v(
                              _vm._s(_vm.getOperationTitle(record.audit_status))
                            )
                          ]),
                          _c("span", { staticClass: "step-time" }, [
                            _vm._v(_vm._s(record.created_at))
                          ]),
                          record.audit_status === "1" &&
                          index == _vm.auditRecords.length - 1
                            ? _c(
                                "div",
                                { staticClass: "archive-actions" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "success",
                                        size: "mini",
                                        icon: "el-icon-folder"
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.handleArchiveConfirm(
                                            record
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("归档确认")]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "danger",
                                        size: "mini",
                                        icon: "el-icon-close"
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.handleProjectReject(record)
                                        }
                                      }
                                    },
                                    [_vm._v("项目驳回")]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ])
                      ]),
                      _c("div", { staticClass: "step-content" }, [
                        _c("div", { staticClass: "step-info" }, [
                          _c("div", { staticClass: "info-item" }, [
                            _c("span", { staticClass: "label" }, [
                              _vm._v("操作人：")
                            ]),
                            _c("span", [_vm._v(_vm._s(record.auditor))])
                          ]),
                          _c(
                            "div",
                            { staticClass: "info-item" },
                            [
                              _c("span", { staticClass: "label" }, [
                                _vm._v("操作类型：")
                              ]),
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    type: _vm.getAuditStatusType(
                                      record.audit_status
                                    ),
                                    size: "small"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.getAuditStatusText(
                                          record.audit_status
                                        )
                                      ) +
                                      "\n                  "
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _c("div", { staticClass: "info-item" }, [
                            _c("span", { staticClass: "label" }, [
                              _vm._v("操作说明：")
                            ]),
                            _c("span", [_vm._v(_vm._s(record.audit_opinion))])
                          ]),
                          record.operation_type === "audit"
                            ? _c("div", { staticClass: "info-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("审核意见：")
                                ]),
                                _c("span", [
                                  _vm._v(_vm._s(record.audit_idea || "-"))
                                ])
                              ])
                            : _vm._e(),
                          record.operation_type === "archive"
                            ? _c("div", { staticClass: "info-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("归档说明：")
                                ]),
                                _c("span", [
                                  _vm._v(_vm._s(record.remark || "-"))
                                ])
                              ])
                            : _vm._e(),
                          record.operation_type === "reject"
                            ? _c("div", { staticClass: "info-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("驳回原因：")
                                ]),
                                _c("span", [
                                  _vm._v(_vm._s(record.remark || "-"))
                                ])
                              ])
                            : _vm._e(),
                          record.operation_type !== "archive" &&
                          record.operation_type !== "reject"
                            ? _c("div", { staticClass: "info-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("相关附件：")
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "attachments-container" },
                                  [
                                    record.operation_type === "audit"
                                      ? [
                                          record.audit_attachments
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "attachments-list"
                                                },
                                                [
                                                  typeof record.audit_attachments ===
                                                  "string"
                                                    ? [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "attachment-item"
                                                          },
                                                          [
                                                            _c(
                                                              "el-link",
                                                              {
                                                                attrs: {
                                                                  type:
                                                                    "primary"
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.handlePreview(
                                                                      {
                                                                        name:
                                                                          record.filename,
                                                                        url:
                                                                          record.audit_attachments
                                                                      }
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    record.filename ||
                                                                      "-"
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    : _vm._l(
                                                        record.audit_attachments,
                                                        function(file, index) {
                                                          return _c(
                                                            "div",
                                                            {
                                                              key: index,
                                                              staticClass:
                                                                "attachment-item"
                                                            },
                                                            [
                                                              _c(
                                                                "el-link",
                                                                {
                                                                  attrs: {
                                                                    type:
                                                                      "primary"
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.handlePreview(
                                                                        file
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      file.name ||
                                                                        "-"
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        }
                                                      )
                                                ],
                                                2
                                              )
                                            : _c("span", [_vm._v("-")])
                                        ]
                                      : record.operation_type === "submit"
                                      ? [
                                          record.solution_attachments &&
                                          record.solution_attachments.length > 0
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "attachments-list"
                                                },
                                                _vm._l(
                                                  record.solution_attachments,
                                                  function(file, index) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        key: index,
                                                        staticClass:
                                                          "attachment-item"
                                                      },
                                                      [
                                                        _c(
                                                          "el-link",
                                                          {
                                                            attrs: {
                                                              type: "primary"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.handlePreview(
                                                                  file
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(file.name)
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  }
                                                ),
                                                0
                                              )
                                            : _c("span", [_vm._v("-")])
                                        ]
                                      : [
                                          record.attachments &&
                                          record.attachments.length > 0
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "attachments-list"
                                                },
                                                _vm._l(
                                                  record.attachments,
                                                  function(file, index) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        key: index,
                                                        staticClass:
                                                          "attachment-item"
                                                      },
                                                      [
                                                        _c(
                                                          "el-link",
                                                          {
                                                            attrs: {
                                                              type: "primary"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.handlePreview(
                                                                  file
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(file.name)
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  }
                                                ),
                                                0
                                              )
                                            : _c("span", [_vm._v("-")])
                                        ]
                                  ],
                                  2
                                )
                              ])
                            : _vm._e()
                        ])
                      ])
                    ],
                    2
                  )
                }),
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "归档确认",
            visible: _vm.archiveDialogVisible,
            width: "500px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.archiveDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "archiveForm",
              attrs: { model: _vm.archiveForm, rules: _vm.archiveRules }
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "归档说明",
                    prop: "archiveNote",
                    "label-width": "100px"
                  }
                },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 4,
                      placeholder: "请输入归档说明"
                    },
                    model: {
                      value: _vm.archiveForm.archiveNote,
                      callback: function($$v) {
                        _vm.$set(_vm.archiveForm, "archiveNote", $$v)
                      },
                      expression: "archiveForm.archiveNote"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.archiveDialogVisible = false
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmArchive }
                },
                [_vm._v("确认")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "项目驳回",
            visible: _vm.rejectDialogVisible,
            width: "500px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.rejectDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "rejectForm",
              attrs: { model: _vm.rejectForm, rules: _vm.rejectRules }
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "驳回原因",
                    prop: "rejectReason",
                    "label-width": "100px"
                  }
                },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 4,
                      placeholder: "请输入驳回原因"
                    },
                    model: {
                      value: _vm.rejectForm.rejectReason,
                      callback: function($$v) {
                        _vm.$set(_vm.rejectForm, "rejectReason", $$v)
                      },
                      expression: "rejectForm.rejectReason"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.rejectDialogVisible = false
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "danger" }, on: { click: _vm.confirmReject } },
                [_vm._v("确认驳回")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "审核确认",
            visible: _vm.auditDialogVisible,
            width: "500px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.auditDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "auditForm",
              attrs: { model: _vm.auditForm, rules: _vm.auditRules }
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "审核意见",
                    prop: "opinion",
                    "label-width": "100px"
                  }
                },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 4,
                      placeholder: "请输入审核意见"
                    },
                    model: {
                      value: _vm.auditForm.opinion,
                      callback: function($$v) {
                        _vm.$set(_vm.auditForm, "opinion", $$v)
                      },
                      expression: "auditForm.opinion"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "附件",
                    prop: "attachments",
                    "label-width": "100px"
                  }
                },
                [
                  _c(
                    "el-upload",
                    {
                      staticClass: "upload-demo",
                      attrs: {
                        action: "#",
                        "http-request": _vm.handleAuditUpload,
                        "on-preview": _vm.handlePreview,
                        "on-remove": _vm.handleAuditAttachmentRemove,
                        "before-remove": _vm.beforeRemove,
                        multiple: "",
                        limit: 3,
                        "on-exceed": _vm.handleExceed,
                        "file-list": _vm.auditForm.attachments
                      }
                    },
                    [
                      _c(
                        "el-button",
                        { attrs: { size: "small", type: "primary" } },
                        [_vm._v("点击上传")]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "el-upload__tip",
                          attrs: { slot: "tip" },
                          slot: "tip"
                        },
                        [_vm._v("文件大小不超过50MB")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.auditDialogVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submitAudit } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }